// Include css
import './confirmPopup.css';

// Ant design
import { Modal } from 'antd';


// popup modal (confirm style)
const confirmEmployeeAction = Modal.confirm;

const showConfirmEmployeeWindow = (obj) => {
    confirmEmployeeAction(obj);
};

export default showConfirmEmployeeWindow;